/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  Button,
  Checkbox,
  Form,
  Grid,
  Header,
  Icon,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { TRANSLATION_FILES, namespaces } from '../../constants/translation';
import { fetchM } from '../../actions/fetchM';
import { flashErrorMessage } from '../../actions/flash';

class QuotationPackageSelection extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }

  static propTypes = {
    calculatePackagePricing: PropTypes.oneOfType([PropTypes.array]).isRequired,
    isBumiUnit: PropTypes.bool,
    isPreviewing: PropTypes.bool,
    newFetch: PropTypes.func,
    onTogglePreview: PropTypes.func,
    projectDefaultBookingFeeAmount: PropTypes.number,
    projectDefaultBumiPackagePricingID: PropTypes.string,
    projectDefaultPackagePricingID: PropTypes.string,
    projectID: PropTypes.string,
    projectName: PropTypes.string,
    projectQuatationCode: PropTypes.string,
    sellingPriceCustomName: PropTypes.string,
    spaValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    t: PropTypes.func,
    token: PropTypes.string,
    unitID: PropTypes.string,
    unitReference: PropTypes.string,
    unitPackagePricings: PropTypes.oneOfType([PropTypes.array]),
  }

  static getPropsToState = (props) => {
    const calculatePackagePricing = props.calculatePackagePricing || [];
    const isPreviewing = props.isPreviewing;
    const token = props.token || '';

    const accordions = {
      base_price: false,
    };

    // assign default package pricing (unit base selling price) to items
    const items = [{
      isSPAValue: true,
      listPrice: props.spaValue,
      projectPackagePricing: {
        name: props.sellingPriceCustomName || 'Selling Price',
        description: 'Unit Base Selling Price',
      },
      projectPackagePricingID: 'base_price',
      spaPrice: props.spaValue,
      totalPrice: props.spaValue,
    }];

    // range through packages and calculations and push into items
    props.unitPackagePricings.sort((a, b) => a.orderPriority - b.orderPriority).forEach((d) => {
      let calculations = [];

      if (props.calculatePackagePricing && props.calculatePackagePricing.some(data => data.id === d.id)) {
        const pupp = props.calculatePackagePricing.find(data => data.id === d.id);
        if (!pupp.isCustomPrice && pupp.projectPackagePricing.packagePricingCalculations) {
          calculations = pupp.projectPackagePricing.packagePricingCalculations.map(c => ({
            ...c,
            isSelected: c.projectPackagePricingItem && c.projectPackagePricingItem.isEnabled && c.applyToBooking,
            isItemRequired: c.projectPackagePricingItem && c.projectPackagePricingItem.isRequired,
          }));
        }
      }

      const newItem = {
        customDescription: d.customDescription,
        customName: d.customName,
        isCustomPrice: d.isCustomPrice,
        isSPAValue: false,
        listPrice: d.listPrice,
        packagePricingCalculations: calculations,
        projectPackagePricingID: d.projectPackagePricingID,
        spaPrice: d.spaPrice,
        totalPrice: d.totalPrice,
      };

      if (d.projectPackagePricing) {
        let iDesc = d.projectPackagePricing.description;
        if (iDesc.includes('\n')) {
          iDesc = iDesc.split('\n').map((desc, idx) => <span key={idx}>{desc}<br /></span>);
        }
        newItem.projectPackagePricing = {
          name: d.projectPackagePricing.name,
          description: iDesc,
        };
      }
      items.push(newItem);

      accordions[d.projectPackagePricingID] = false;
    });

    // added quotation package to be used to generate quotation
    const quotationPackage = {
      packagePricingID: props.projectDefaultPackagePricingID ? props.projectDefaultPackagePricingID : '',
      bookingFeeAmount: props.projectDefaultBookingFeeAmount ? props.projectDefaultBookingFeeAmount : 0,
      marginOfFinance: '90%',
      calculations: [],
    };

    // assign default selected package
    if (props.isBumiUnit && props.projectDefaultBumiPackagePricingID) {
      quotationPackage.packagePricingID = props.projectDefaultBumiPackagePricingID;
    }
    if (quotationPackage.packagePricingID !== '') {
      accordions[quotationPackage.packagePricingID] = true;
    }

    return {
      accordions,
      calculatePackagePricing,
      isPreviewing,
      items,
      quotationPackage,
      token,
    };
  }
  constructor(props) {
    super(props);
    const state = QuotationPackageSelection.getPropsToState(props);

    // added 0% to 100% options
    const percentageOpts = [];
    for (let i = 100; i >= 0; i -= 1) {
      percentageOpts.push({
        key: i,
        value: `${i}%`,
        text: `${i}%`,
      });
    }

    this.state = {
      ...state,
      items: [],
      loading: false,
      percentageOpts,
      printQuotationModal: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const state = QuotationPackageSelection.getPropsToState(nextProps);
    this.setState(state);
  }

  handleAccordionChange = (e, ppID) => {
    e.preventDefault();
    if (ppID !== 'base_price') {
      const newAccordions = this.state.accordions;
      newAccordions[ppID] = !newAccordions[ppID];
      this.setState({ accordions: newAccordions });
    }
  }

  findSubTotalCalcIndex = (idx, data) => {
    // find nearest subtotal calculation index
    for (let i = idx - 1; i >= 0; i -= 1) {
      if (data[i].isSubTotal) {
        return i;
      }
    }
    return -1;
  }

  handleCalculationCheckboxChange = (e, d, calc) => {
    const { value, checked } = d;
    const { items } = this.state;

    if (calc) {
      const newItems = [...items];
      const packageIdx = newItems.findIndex(p => p.projectPackagePricingID === calc.projectPackagePricingID);
      if (packageIdx > -1) {
        const calcIdx = newItems[packageIdx].packagePricingCalculations.findIndex(c => c.id === value);
        if (calcIdx > -1) {
          newItems[packageIdx].packagePricingCalculations[calcIdx].isSelected = checked;
          this.setState({ items: [...newItems] });
        }
      }
    }
  }

  handleDisplayModal = isOpen => this.setState({ printQuotationModal: isOpen });

  handleModalInputChange = (e, d) => {
    const { quotationPackage } = this.state;
    quotationPackage[d.name] = d.value;

    this.setState({ quotationPackage });
  }

  handlePackageChange = (e, d) => {
    const { value } = d;
    const newAccordions = this.state.accordions;
    if (value !== 'base_price') {
      newAccordions[value] = true;
    }
    const qp = this.state.quotationPackage;
    qp.packagePricingID = value;

    this.setState({ quotationPackage: qp, accordions: newAccordions });
  }

  generateQuotationForm = async () => {
    await this.setState({ loading: true });
    const { store } = this.context;
    const { projectID, projectQuatationCode, unitID, unitReference, t } = this.props;
    const { items, quotationPackage } = this.state;

    // validate item
    const itemIdx = items.findIndex(i => i.projectPackagePricingID === quotationPackage.packagePricingID);
    if (itemIdx <= -1) {
      await store.dispatch(flashErrorMessage({ message: t('Package not found. Please refresh the page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }

    // send selected calculations to backend
    const selectedPackageCalcs = items[itemIdx].packagePricingCalculations;
    if (selectedPackageCalcs && selectedPackageCalcs.length > 0) {
      for (let i = 0; i < selectedPackageCalcs.length; i += 1) {
        // find subtotal calculation
        if (selectedPackageCalcs[i].isSelected && selectedPackageCalcs[i].projectPackagePricingItem && selectedPackageCalcs[i].projectPackagePricingItem.calculationType === 'deduct_from_sub_total') {
          const subIdx = this.findSubTotalCalcIndex(i, selectedPackageCalcs);
          if (subIdx > -1) {
            selectedPackageCalcs[subIdx].isSelected = true;
          }
        }
      }
    }
    quotationPackage.calculations = selectedPackageCalcs.filter(c => c.isSelected);

    quotationPackage.bookingFeeAmount = Number(quotationPackage.bookingFeeAmount);
    if (isNaN(quotationPackage.bookingFeeAmount)) {
      await store.dispatch(flashErrorMessage({ message: 'Booking fee amount is not a number' }));
      return;
    }

    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${projectID}/units/${unitID}/print_quotation/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(quotationPackage),
      }));
    } catch (err) {
      await this.setState({ loading: false });

      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }

      store.dispatch(flashErrorMessage(err));
      return;
    }
    // Download PDF file
    // Convert response to blob
    const blob = await res.blob();

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element to trigger the download
    const link = document.createElement('a');
    link.href = url;

    // set filename
    let filename = 'Quotation.pdf';
    if (projectQuatationCode && unitReference) {
      filename = `Quotation-${projectQuatationCode},${unitReference}.pdf`;
    }
    link.download = filename;

    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Clean up
    link.remove();
    window.URL.revokeObjectURL(url);

    this.setState({ loading: false, printQuotationModal: false }, () => {
      // refetch all including project activity logs
      this.props.newFetch();
    });
  }

  renderApplyToBookingRemarks = (title, applyToBooking) => {
    const { t } = this.props;
    return (
      <span>
        {title}
        <span className="packagePricingApplyToBookingFlag" style={{ color: applyToBooking ? 'green' : 'red' }}>
          {t(`Formula item will${!applyToBooking ? ' not' : ''} be applied onto the initial booking`)}
        </span>
      </span>
    );
  }

  renderSubtotal = () => {
    const { t } = this.props;
    return (
      <Grid.Column className="quotation-subtitle"><h5>{t('Sub Total')}</h5></Grid.Column>
    );
  }

  renderCalculations = ppc => (
    <Grid.Column className="quotation-calculations">
      <Checkbox
        value={ppc.id}
        checked={ppc.isSelected}
        disabled={ppc.isItemRequired}
        onChange={(e, d) => this.handleCalculationCheckboxChange(e, d, ppc)}
        label={(
          <label>
            {
              ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.name
                ? this.renderApplyToBookingRemarks(ppc.projectPackagePricingItem.name, ppc.applyToBooking)
                : ''
            }
          </label>
        )}
      />
      <small>
        {
          ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.description
            ? ppc.projectPackagePricingItem.description
            : ''
        }
      </small>
    </Grid.Column>
  );

  renderPackageAndCalculations = (data, idx) => {
    const { t } = this.props;
    const { accordions, quotationPackage } = this.state;
    const listCalculations = data.packagePricingCalculations && data.packagePricingCalculations.length > 0 ? data.packagePricingCalculations.filter(ppc => ppc.category === 'list_price') : [];
    const spaCalculations = data.packagePricingCalculations && data.packagePricingCalculations.length > 0 ? data.packagePricingCalculations.filter(ppc => ppc.category === 'spa_price') : [];
    return (
      <div key={idx}>
        <Accordion.Title
          key={idx}
          active={accordions[data.projectPackagePricingID]}
          index={data.projectPackagePricingID}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Checkbox
                  radio
                  checked={quotationPackage.packagePricingID === data.projectPackagePricingID}
                  value={data.projectPackagePricingID}
                  onClick={this.handlePackageChange}
                  label={(
                    <label>
                      <h3>
                        {data.projectPackagePricingID !== '' ?
                        (data.projectPackagePricing && data.projectPackagePricing.name ? data.projectPackagePricing.name : '') :
                        ''}
                      </h3>
                    </label>
                  )}
                />
                <small>
                  {
                    data.projectPackagePricingID !== '' ?
                      (data.projectPackagePricing && data.projectPackagePricing.description ? data.projectPackagePricing.description : '') :
                    ''
                  }
                </small>
              </Grid.Column>
              <Grid.Column>
                {
                  data.projectPackagePricingID !== 'base_price' && (
                    <Button basic disabled={quotationPackage.packagePricingID === data.projectPackagePricingID} onClick={e => this.handleAccordionChange(e, data.projectPackagePricingID)}>
                      <Icon name={`chevron ${accordions[data.projectPackagePricingID] ? 'up' : 'down'}`} />
                    </Button>
                  )
                }
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Title>
        <Accordion.Content active={accordions[data.projectPackagePricingID]}>
          {
            !data.isSPAValue && (
              <Grid.Row columns={16}>
                <Grid.Column textAlign="left" width={8}><h4>{t('Unit Base Selling Price')}</h4></Grid.Column>
              </Grid.Row>
            )
          }
          {
            listCalculations.map((ppc, key) => (
              <Grid.Row columns={16} key={key}>
                { ppc.isSubTotal ? this.renderSubtotal() : this.renderCalculations(ppc) }
              </Grid.Row>
            ))
          }
          { !data.isSPAValue && this.renderSubtotal() }
          {
            spaCalculations.map((ppc, key) => (
              <Grid.Row key={key}>
                { ppc.isSubTotal ? this.renderSubtotal() : this.renderCalculations(ppc) }
              </Grid.Row>
            ))
          }
        </Accordion.Content>
      </div>
    );
  }

  renderPrintQuotationModal = () => {
    const { t } = this.props;
    const { loading, percentageOpts, printQuotationModal, quotationPackage } = this.state;
    return (
      <Modal
        className="quotation-modal"
        closeOnDimmerClick={false}
        disabled={loading}
        onClose={() => this.handleDisplayModal(false)}
        open={printQuotationModal}
        size="tiny"
      >
        <Modal.Header>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Header as="h3" content={t('Print quotation')} />
              </Grid.Column>
              <Grid.Column>
                <Button basic icon="close" onClick={() => this.handleDisplayModal(false)} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            Fill up the following and click Generate.
          </Modal.Description>
          <Form.Input
            disabled={loading}
            label={(
              <label>
                Part first 10% of the Purchase Price
                <span> *</span>
              </label>
            )}
            name="bookingFeeAmount"
            onChange={this.handleModalInputChange}
            value={quotationPackage.bookingFeeAmount}
          />
          <Form.Select
            disabled={loading}
            fluid
            label={(
              <label>
                {t('Margin of financing')}
                <span> *</span>
              </label>
            )}
            name="marginOfFinance"
            onChange={this.handleModalInputChange}
            options={percentageOpts}
            selectOnBlur={false}
            value={quotationPackage.marginOfFinance}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button basic disabled={loading} onClick={() => this.handleDisplayModal(false)} content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />
          <Button color="blue" disabled={loading} onClick={this.generateQuotationForm} content="Generate" />
        </Modal.Actions>
      </Modal>
    );
  }

  render() {
    const { t, onTogglePreview } = this.props;
    const { isPreviewing, items, quotationPackage } = this.state;
    return (
      <Grid className="quotation-grid">
        {this.renderPrintQuotationModal()}
        {
          isPreviewing && (
            <Grid.Row>
              <Grid.Column>
                <Button
                  content={t('Close', { ns: TRANSLATION_FILES.translation })}
                  icon={'close'}
                  name="showQuotationOpts"
                  onClick={() => onTogglePreview(false)}
                  size="tiny"
                />
              </Grid.Column>
              <Grid.Column>
                <Button
                  color="teal"
                  content={t('Print quotation')}
                  disabled={!quotationPackage.packagePricingID}
                  name="printQuotation"
                  onClick={() => this.handleDisplayModal(true)}
                />
              </Grid.Column>
            </Grid.Row>
          )
        }
        {
          isPreviewing && items && items.length > 0 && (
            <Grid.Row>
              <Grid.Column>
                <Accordion>
                  {
                    items.map((data, idx) => (
                      this.renderPackageAndCalculations(data, idx)
                  ))}
                </Accordion>
              </Grid.Column>
            </Grid.Row>
          )
        }
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(QuotationPackageSelection);



// WEBPACK FOOTER //
// ./src/components/QuotationPackageSelection/QuotationPackageSelection.jsx